// @flow
import React from "react";
import ShieldIconSvg from "../../../svg/qicons/shieldIcon.svg";
import type { IconSizes } from "../../../types/Icons";
import getSizeClass from "../../../helpers/getIconSizeClassname";

import styles from "./shieldIcon.module.scss";

type Props = {
  size: IconSizes
};

const ShieldIcon = ({ size = "1x" }: Props) => {
  const sizeClass = getSizeClass(size);

  return <ShieldIconSvg className={`${styles.base} ${sizeClass}`} />;
};

export default ShieldIcon;
